// eslint-disable-next-line no-undef
import { Clipboard } from '@capacitor/clipboard';
console.log(Clipboard);

const writeToClipboard = async () => {
    await Clipboard.write({
        string: "Hello World!"
    });
};

writeToClipboard();
